export enum ModalIconType {
    SUCCESS = 0,
    WARNING = 1
}
